import { lazy } from "react";
import { ScreenLoader } from "../utils/ScreenLoader";
import { AuthGuard } from "../utils/AuthGuard";
import { RoleGuard } from "../contexts/RoleGuard"; // Import RoleGuard
import { Outlet } from "react-router";

const AgentReport = ScreenLoader(
  lazy(() => import("../screens/agent-screen/AgentReport")),
);

const AgentDailyReport = ScreenLoader(
  lazy(() => import("../screens/agent-screen/AgentDailyReport")),
);

export const ReportRoute = () => ({
  path: "report",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "total-user",
      element: (
        <RoleGuard
          requiredPermission="agentReport"
          requiredActions={["isRead"]}
        >
          <AgentReport />
        </RoleGuard>
      ),
    },
    {
      path: "total-daily",
      element: (
        <RoleGuard
          requiredPermission="agentReport"
          requiredActions={["isRead"]}
        >
          <AgentDailyReport />
        </RoleGuard>
      ),
    },
  ],
});
